export default {
  '学年学期管理':'School Year and Semester Management',
  '至':'To',
  '新增学年':'Add a New School Year',
  '秋季学期':'Autumn Semester',
  '春季学期':'Spring Semester',
  '寒假':'Winter Vacation',
  '暑假':'Summer Vacation',
  '是否删除{year}学年学期？':'Are you sure you want to delete the {year} school year and semester?',
  '编辑学年':'Edit the School Year',
  '学期时间':'Semester Time',
  '入学年份管理':'Enrollment Year Management',
  '学段':'Education Stage',
  '毕业状态':'Graduation Status',
  '当前年级':'Current Grade',
  '入学年份':'Enrollment Year',
  '新增入学年份':'Add a New Enrollment Year',
  '编辑入学年份':'Edit the Enrollment Year',
  '是否删除{gradeName}？':'Are you sure you want to delete {gradeName}?',
  '入学年份删除成功':'Enrollment year deleted successfully',
  '新增入学年份成功':'New enrollment year added successfully',
  '班级管理':'Class Management',
  '新增班级':'Add a New Class',
  '班级码':'Class Code',
  '班级导入模板':'Class Import Template',
  '批量新增班级':'Batch Add New Classes',
  '所属学级':'Affiliated Grade Level',
  '当前年级':'Current Grade',
  '班级名称':'Class Name',
  '班级编号':'Class Number',
  '班级人数':'Class Size',
  '编辑班级':'Edit the Class',
  '新增班级成功':'New class added successfully',
  '编辑班级成功':'Class edited successfully',
  '是否批量删除所选班级？':'Are you sure you want to batch delete the selected classes?',
  '请勾选要删除的班级':'Please select the classes to be deleted',
  '是否删除班级{classFullName}？':'Are you sure you want to delete the class {classFullName}?',
  '导入班级时关联教师信息，可以在导入时一并创建教师角色':'When importing classes, associate teacher information to create teacher roles during the import process.',
  '所属学级不能为空':'The affiliated grade level cannot be empty',
  '更多班号':'More Class Numbers',
  '班级编码':'Class Code',
  '教师姓名':'Teacher Name',
  '根据所选编号区间，批量生成班级，已有编号自动跳过':'Generate classes in batches based on the selected number range. Existing numbers will be skipped automatically.',
  '新增年级':'Add a New Grade',
  '班级编码不能为空':'The class code cannot be empty',
  '班级编码范围有误':'The class code range is incorrect',
  '班级编码不超过99':'The class code should not exceed 99',
  '班级导出':'Class Export',
  '院系导出':'College Export',
  '专业导出':'Major Export',

  '机构列表':'Organization List',
  '请输入机构名\机构代码':'Please enter the organization name or code',
  '新增机构':'Add a New Organization',
  '设备激活码':'Device Activation Code',
  '重置激活码':'Reset the Activation Code',
  '可激活设备数量':'Number of Activable Devices',
  '已激活设备':'Activated Devices',
  '机构名称':'Organization Name',
  '机构代码':'Organization Code',
  '上级机构':'Superior Organization',
  '系统管理员':'System Administrator',
  '确认要删除该机构：{orgName}？':'Are you sure you want to delete the organization: {orgName}?',
  '可激活数量必须大于已激活数量。':'The number of activable devices must be greater than the number of activated devices.',
  '上级机构名称':'Name of the Superior Organization',
  '管理员密码':'Administrator Password',
  '编辑机构':'Edit the Organization',
  '密码不能少于6位':'The password cannot be less than 6 digits',
  '密码不能多于20位':'The password cannot be more than 20 digits',
  '系统管理员{newVal}':'System Administrator {newVal}',
  '院系':'Department',
  '专业':'Major',
  '根据班级名称模糊查询':'Fuzzy query based on the class name',
  '批量添加':'Batch Add',
  '院系管理':'Department Management',
  '根据名称或代码搜索':'Search by name or code',
  '批量新增院系':'Batch Add New Departments',
  '院系名称':'Department Name',
  '院系代码':'Department Code',
  '上级组织':'Superior Organization',
  '编辑院系':'Edit the Department',
  '请输入两位数字代码':'Please enter a two - digit code',
  '新增院系':'Add a New Department',
  '专业管理':'Major Management',
  '根据专业、院系名称或代码搜索':'Search by major, department name or code',
  '批量新增专业':'Batch Add New Majors',
  '专业名称':'Major Name',
  '专业代码':'Major Code',
  '所属院系':'Affiliated Department',
  '所属院系代码':'Affiliated Department Code',
  '学制':'Educational System',
  '请选择修学年限':'Please select the length of study',
  '新增专业':'Add a New Major',
  '编辑专业':'Edit the Major',
  '请选择添加范围':'Please select the range to add',
  '请按照模板格式进行导入，':'Please import according to the template format，',
  '点击下载模板':'Click to download template',
  '点击或将文件拖拽到这里':'Click or drag the file here',
  '上传支持':'Upload Support',
  '上传中，请稍等':'Uploading, please wait...',
  '创建成功':'Creation successful',
  '创建失败':'Creation failed',
  '导出失败记录':'Export Failure Record',
  '部分数据创建失败，请导出失败记录，修改后重新上传。':'Some data creation failed. Please export the failed records and upload them again after modification。',
}    